/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Box, Flex, Container, Heading, Text } from "@theme-ui/components"
import { i18nContext, languages } from "../context/i18nContext"
import Header from "./header"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import Footer from "./footer"
import Canonical from "./canonical"
import { InboundLink, OutboundLink } from "../components/link"
import * as Scroll from "react-scroll"
import { ExternalLink, Phone } from "react-feather"
import { MagicLink } from "../utils/magicLink"
import { ArrowRightCircle } from "react-feather"
import { useBreakpointIndex } from "@theme-ui/match-media"
import Texture from "../assets/images/texture.svg"
import { BannerProvider } from "../context/BannerContext"

const Layout = ({ children, locale, i18nPaths, home, color }) => {
  const data = useStaticQuery(graphql`
    query SiteQuery {
      datoCmsSite: datoCmsSite {
        locale
      }
      gatsbySite: site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  const breakpointIndex = useBreakpointIndex()
  const LinkScroll = Scroll.Link
  let isScreenSmall = false
  if (typeof window !== "undefined") {
    isScreenSmall = window.matchMedia("(max-width: 1300px)").matches
  }
  return (
    <i18nContext.Provider
      value={languages[locale] || languages[data.datoCmsSite.locale]}
    >
      <LanguageSwitcherContext.Provider
        value={{ activeLocale: locale, paths: i18nPaths || [] }}
      >
        <BannerProvider>
          <Canonical
            siteUrl={data.gatsbySite.siteMetadata.siteUrl}
            paths={i18nPaths}
          />

          <Flex
            id="main"
            sx={{
              flexDirection: "column",
              minHeight: "100vh",
            }}
          >
            <Header color={color} />
            <Box
              as="main"
              sx={{
                flexGrow: 1,
                width: "100%",
              }}
            >
              {children}
            </Box>
            <Footer />
          </Flex>
          <Box
            sx={{
              position: "fixed",
              bottom: "0",
              backgroundColor: "secondary",
              width: "100%",
              width: "100%",
              zIndex: 100,
              a: {
                textDecoration: "none",
              },
            }}
          >
            <Container sx={{ py: [2, 2, 2, 2] }}>
              <Flex
                sx={{ justifyContent: "space-between", alignItems: "center" }}
              >
                <Box>
                  <Heading
                    as="h3"
                    variant="h4"
                    sx={{ my: [0], fontSize: [1, 5], color: "light" }}
                  >
                    Per info e richieste
                  </Heading>
                </Box>
                <Flex>
                  <Box sx={{ pr: [2] }}>
                    <OutboundLink href="tel:800480110">
                      <Flex
                        sx={{
                          minHeight: "31px",
                          px: [2, 3],
                          py: [1, 2],
                          fontSize: [0],
                          textDecoration: "none",
                          cursor: "pointer",
                          color: "light",
                          border: "1px solid",
                          borderColor: "light",
                          "&:hover": {
                            bg: "dark",
                          },
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box sx={{ pr: [2] }}>
                          <Phone size={18} />
                        </Box>
                        <Box>800 480110</Box>
                      </Flex>
                    </OutboundLink>
                  </Box>
                  <Box sx={{ height: "100%", a: { display: "flex" } }}>
                    <LinkScroll
                      to="contactForm"
                      href="#"
                      spy={false}
                      smooth={true}
                      duration={500}
                      onClick={() => {
                        if (typeof window !== "undefined") {
                          window.dataLayer = window.dataLayer || []

                          window.dataLayer.push({
                            event: "clic_compila_form",
                            pageURL: window.location.href,
                          })
                        }
                      }}
                    >
                      <Flex
                        sx={{
                          minHeight: "31px",
                          px: [2, 3],
                          py: [1, 2],
                          fontSize: [0, 2],
                          textDecoration: "none",
                          cursor: "pointer",
                          backgroundColor: "light",
                          color: "secondary",
                          border: "1px solid",
                          borderColor: "light",
                          "-webkit-transition": "background-color .2s linear",
                          "-ms-transition": "background-color .2s linear",
                          transition: "background-color .2s linear",
                          "&:hover": {
                            color: "light",
                            bg: "dark",
                          },
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box>compila il form</Box>
                      </Flex>
                    </LinkScroll>
                  </Box>
                </Flex>
              </Flex>
            </Container>
          </Box>
        </BannerProvider>
      </LanguageSwitcherContext.Provider>
    </i18nContext.Provider>
  )
}

export default Layout
